import React from "react";
import { Button } from "newui/components/Button";
import Modal from "newui/components/ui/Modal/Modal";
import { TotpEnrolmentWizard } from "./TotpEnrolmentWizard";

export interface Enforced2faSetupModalProps {
	isOpen: boolean;
	onComplete: () => void;
	onLogout: () => void;
}

/**
 * Un-dismissable 2FA enrolment modal shown when the user's company enforces 2FA
 * and the user has not yet enrolled. There is no close affordance — the user must
 * either complete enrolment or log out.
 */
export const Enforced2faSetupModal = ({
	isOpen,
	onComplete,
	onLogout,
}: Enforced2faSetupModalProps) => {
	return (
		<Modal
			isOpen={isOpen}
			// Non-dismissable: no overlay/esc close, no close button, no-op onClose.
			onClose={() => undefined}
			closeOnEsc={false}
			closeOnOverlayClick={false}
			hideCloseButton
			isCentered
			size="lg"
			title="Set up two-factor authentication"
			description="Your organisation requires two-factor authentication. Set it up now to continue, or log out."
			customFooter={
				<div className="flex justify-end px-6 pb-6">
					<Button
						type="button"
						btntype="secondary"
						onClick={onLogout}
						data-testid="enforced-2fa-logout-btn"
					>
						Log out
					</Button>
				</div>
			}
		>
			<div className="px-6" data-testid="enforced-2fa-wizard">
				<TotpEnrolmentWizard onAlreadyEnabled={onComplete} onComplete={onComplete} />
			</div>
		</Modal>
	);
};
